// Domain-based routing: cms.hitechsilico.in -> staff/admin CMS, client.hitechsilico.in (or portal.*) -> client portal.
// On any other host (preview, localhost, emergent.host) both trees stay accessible (default mode).

const host = (typeof window !== "undefined" ? window.location.hostname : "").toLowerCase();

export const isPortalHost = () => host.startsWith("portal.") || host.startsWith("client.");
export const isCmsHost = () => host.startsWith("cms.");
// A "dedicated" host is one that should lock the user to a single app.
export const isDedicatedHost = () => isPortalHost() || isCmsHost();

// Build the client-portal login URL — same domain, /client/login path.
export const portalLoginUrl = () => `${window.location.origin}/client/login`;
